var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showPagination
    ? _c(
        "nav",
        {
          staticClass: "pagination",
          attrs: { role: "navigation", "aria-label": "pagination" }
        },
        [
          _c(
            "ul",
            { staticClass: "pagination-list" },
            [
              _c("li", [
                _vm.buttons.length > 0
                  ? _c("a", {
                      staticClass: "pagination-previous",
                      attrs: { disabled: _vm.currentPage < 2 },
                      domProps: { textContent: _vm._s(_vm.previousText) },
                      on: { click: _vm.previous }
                    })
                  : _vm._e()
              ]),
              _vm.showFirstPageButton
                ? _c("li", [
                    _c("a", {
                      staticClass: "pagination-link",
                      attrs: { "aria-label": _vm.goToText + " 1" },
                      domProps: { textContent: _vm._s(1) },
                      on: {
                        click: function($event) {
                          return _vm.goPage(1)
                        }
                      }
                    })
                  ])
                : _vm._e(),
              _vm.buttons[0] > 2
                ? _c("li", [
                    _c("span", { staticClass: "pagination-ellipsis" }, [
                      _vm._v("\n        …\n      ")
                    ])
                  ])
                : _vm._e(),
              _vm._l(_vm.buttons, function(button) {
                return _c("li", { key: button }, [
                  _c("a", {
                    staticClass: "pagination-link",
                    class: { "is-current": button === _vm.currentPage },
                    attrs: {
                      "aria-label":
                        (button === _vm.currentPage
                          ? _vm.pageText
                          : _vm.goToText) +
                        " " +
                        button,
                      "aria-current":
                        button === _vm.currentPage ? "page" : false
                    },
                    domProps: { textContent: _vm._s(button) },
                    on: {
                      click: function($event) {
                        return _vm.goPage(button)
                      }
                    }
                  })
                ])
              }),
              _vm.buttons[_vm.buttons.length - 1] < _vm.pagesTotal - 1
                ? _c("li", [
                    _c("span", { staticClass: "pagination-ellipsis" }, [
                      _vm._v("\n        …\n      ")
                    ])
                  ])
                : _vm._e(),
              _vm.showLastPageButton
                ? _c("li", [
                    _c("a", {
                      staticClass: "pagination-link",
                      attrs: {
                        "aria-label": _vm.goToText + " " + _vm.pagesTotal
                      },
                      domProps: { textContent: _vm._s(_vm.pagesTotal) },
                      on: {
                        click: function($event) {
                          return _vm.goPage(_vm.pagesTotal)
                        }
                      }
                    })
                  ])
                : _vm._e(),
              _c("li", [
                _vm.buttons.length > 0
                  ? _c("a", {
                      staticClass: "pagination-next",
                      attrs: { disabled: _vm.currentPage > _vm.pagesTotal - 1 },
                      domProps: { textContent: _vm._s(_vm.nextText) },
                      on: { click: _vm.next }
                    })
                  : _vm._e()
              ])
            ],
            2
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }